import React from "react";
import StaticPostLayout from "../components/StaticPostLayout";
import MapGreatSmokyMountains from "../components/Maps/great-smoky-mountains";
import GreatSmokyMountainsInfo from "../components/TripInfo/great-smoky-mountains";

class GreatSmokyMountains extends React.Component {
  render() {
    return (
      <StaticPostLayout
        title="Great Smoky Mountains National Park: 4-Day Itinerary"
        category="National Parks"
        slug="great-smoky-mountains-national-park-itinerary"
        excerpt="Explore the most visited national park in the US — old-growth forests, waterfalls, black bears, and mountain scenery across Tennessee and North Carolina."
        tags={["National Parks", "Hiking", "Wildlife", "East Coast", "Free Entry"]}
        readTime="8 min read"
        mapComponent={<MapGreatSmokyMountains />}
        whereToStay={[
          { name: 'Hotels in Gatlinburg', type: 'Main Gateway · Gatlinburg, TN', url: 'https://www.booking.com/searchresults.html?ss=Gatlinburg%2C+Tennessee' },
          { name: 'Cabins in Pigeon Forge', type: 'Cabins & Rentals · Pigeon Forge, TN', url: 'https://www.booking.com/searchresults.html?ss=Pigeon+Forge%2C+Tennessee' },
          { name: 'Hotels in Cherokee', type: 'NC Entrance · Cherokee, NC', url: 'https://www.booking.com/searchresults.html?ss=Cherokee%2C+North+Carolina' },
        ]}
      >
        <GreatSmokyMountainsInfo />
      </StaticPostLayout>
    );
  }
}

export default GreatSmokyMountains;
